











































import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrderComplainModel } from '@/models/order-complain';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class OrderComplain extends Vue {
    @Prop({default: []})
    private orderComplains!: OrderComplainModel[];

    private async viewComplain(complain: any) {
        let routeData = this.$router.resolve({ name: 'detail-order-complain', params: { orderId: complain.orderId, complainId: complain.id, orderType: '1' } });
        if (complain.orderType == APP_CONFIG.ORDER_TYPE.deposit) {
            routeData = this.$router.resolve({ name: 'detail-deposit-complain', params: { orderId: complain.orderId, complainId: complain.id, orderType: '2' } });
        } else if (complain.orderType == APP_CONFIG.ORDER_TYPE.quotation) {
            routeData = this.$router.resolve({ name: 'detail-quotation-complain', params: { orderId: complain.orderId, complainId: complain.id, orderType: '5' } });
        }
        window.open(routeData.href, '_blank');
    }
}
